
import * as angular from "angular";
import * as moment from "moment";
import { StateService } from "@uirouter/angularjs";

import { VehicleService } from "@services/vehicle.service";
import { DriverService } from "@services/driver.service";
import { DriverAssignmentService } from "@services/driverAssignment.service";
import { VeriDate } from "@services/veriDate.service";
import { MessageService } from "./service/messaging.service";
import { GroupMessageController } from "./groupMessage.controller";
import { Conversation } from "./models/conversation";
import { VehicleModel } from "../../../model/VehicleModel";
import { IMessageModel } from "./models/IMessageModel";

import "./messaging.scss";

export class MessagingController {

    isLoading = false;

    selectedConversation: Conversation;
    conversations: Conversation[];
    conversationsDisplay: Conversation[];

    messageReplyExpiryId: number;

    conversationFilter: string = "";

    sendingGroupMessage = false;

    latestMessageUpdateIntervalPromise: angular.IPromise<any>;

    //updateInterval = 300 * 1000; // X Seconds between updates

    static $inject = ["$scope", "$interval", "$state", "$mdDialog", "messageService", "vehicleService", "driverService", "driverAssignmentService", "veriDate", "$filter"];

    constructor(
        private $scope: angular.IScope,
        private $interval: angular.IIntervalService,
        private $state: StateService,
        private $mdDialog: angular.material.IDialogService,
        private messageService: MessageService,
        private vehicleService: VehicleService,
        private driverService: DriverService,
        private readonly driverAssignmentService: DriverAssignmentService,
        private veriDate: VeriDate,
        private $filter: angular.IFilterService) {

        this.selectedConversation = new Conversation(this.messageService, this.$filter);

        this.isLoading = true;
        this.driverAssignmentService
            .getVehiclesWithDrivers({ includePeripheralMappings: true })
            .then(vehicles => {

                this.conversations = [];

                vehicles.forEach(v => {
                    if (v.vorRecord) {
                        return;
                    }

                    var conversation = new Conversation(this.messageService, this.$filter);
                    conversation.vehicle = v as VehicleModel;

                    this.conversations.push(conversation);
                });

                this.conversationsDisplay = this.conversations.slice();

                this.updateLatestMessages()
                    .then(latestConversation => {

                        if (this.$state.params["vehicle"]) {
                            latestConversation = this.findConversation(parseInt(this.$state.params["vehicle"]));
                        }

                        this.selectConversation(latestConversation || this.conversations[0]);
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });

                this.updateMessageUnreadCounts();
            });

        // Todo: Put back in once getting unread messages is fast
        //this.latestMessageUpdateIntervalPromise = this.$interval(() => {
        //    this.updateLatestMessages()
        //        .then(() => {
        //            this.updateMessageUnreadCounts();
        //        });

        //}, this.updateInterval);

        $scope.$on("$destroy", () => {
            this.onDestroy();
        });
    }

    selectConversation(conversation: Conversation): void {

        if (!conversation /*|| this.selectedConversation === conversation*/) {
            return;
        }

        this.selectedConversation = conversation;

        this.selectedConversation.clearMessages();

        this.$state.go(this.$state.current.name, { vehicleId: conversation.vehicle.Id }, { notify: false });
    }

    sendGroupMessage(groupId: number, messageBody: string, expiryCode: number) {
        const newMessage = this.messageService.createMessageModel(messageBody, expiryCode);
        newMessage.GroupId = groupId;

        this.sendingGroupMessage = true;

        return this.messageService
            .sendMessage(newMessage)
            .then(() => {
                this.updateLatestMessages();
            })
            .finally(() => {
                this.sendingGroupMessage = false;
            });
    }

    showSendGroupMessage(ev: MouseEvent) {

        const options: angular.material.IDialogOptions = {
            preserveScope: true,
            //scope: <any>this,
            //fullscreen: useFullScreen,
            targetEvent: ev,
            clickOutsideToClose: true,
            parent: angular.element(document.body),
            template: require("./groupMessage.dialog.html"),
            controller: GroupMessageController,
            controllerAs: "$ctrl"
        };

        this.$mdDialog
            .show(options)
            .then((groupMessageConfig) => {
                this.sendGroupMessage(groupMessageConfig.groupId,
                    groupMessageConfig.messageBody,
                    groupMessageConfig.expiryId);
            });
    }

    onSearchChange() {
        this.conversationsDisplay = [];

        const searchTerm = (this.conversationFilter?.length) ? this.conversationFilter.toLowerCase() : null;

        if (!searchTerm) {
            this.conversationsDisplay = this.conversations;

            this.$scope.$applyAsync();
            return;
        }

        this.conversations.forEach(c => {
            if (c.vehicle.Reg.toLowerCase().indexOf(searchTerm) >= 0
                || (c.vehicle.Driver && c.vehicle.Driver.Name.toLowerCase().indexOf(searchTerm) >= 0)) {
                this.conversationsDisplay.push(c);
            }
        });

        this.$scope.$applyAsync();
    }

    conversationUpdated(messages: IMessageModel[]) {
        //console.log("conversationUpdated", messages.length);

        if (!this.selectedConversation || !messages || messages.length === 0) {
            return;
        }

        //console.log("conversationUpdated");
        // Todo: This is not particularily efficient at all, needs some work, especially the message conversation component!!

        //this.selectedConversation.applyNewMessages(messages);
        //this.setLatestMessages(messages);
        this.updateLatestMessages();
    }

    private updateLatestMessages(): angular.IPromise<Conversation> {
        return this.messageService
            .getLatestMessages()
            .then(latestMessages => {
                return this.setLatestMessages(latestMessages);
            });
    }

    private updateMessageUnreadCounts(): angular.IPromise<any> {

        return this.messageService
            .getMessageUnreadCounts()
            .then(unreadMessages => {
                angular.forEach(this.conversations, conversation => {
                    conversation.unreadMessageCount = 0;
                });

                angular.forEach(unreadMessages, unreadMessage => {
                    var conversation = this.findConversation(unreadMessage.VehicleId);
                    if (conversation) {
                        conversation.unreadMessageCount = unreadMessage.UnreadMessages;
                    }
                });

                return unreadMessages;
            });
    }

    private findConversation(vehicleId: number) {
        for (let i = 0; i < this.conversations.length; i++) {
            const c = this.conversations[i];

            if (c.vehicle.Id === vehicleId) {
                return c;
            }
        }

        return null;
    }

    private setLatestMessages(latestMessages: IMessageModel[]): Conversation {

        var mostRecentConvo: Conversation = null;

        latestMessages.forEach(lm => {
            var convo = this.findConversation(lm.VehicleId);

            if (convo) {
                if (lm.Id > convo.lastMessage.Id) {
                    convo.lastMessage = lm;
                }

                if (mostRecentConvo == null || moment(lm.TimestampQueued) > moment(mostRecentConvo.lastMessage.TimestampQueued)) {
                    mostRecentConvo = convo;
                }
            }
        });

        return mostRecentConvo;
    }

    private onDestroy() {
        if (this.latestMessageUpdateIntervalPromise) {
            this.$interval.cancel(this.latestMessageUpdateIntervalPromise);
        }
    }
}
